import { IAMPConfigs } from "../models/IAMPSettings";
import { IPaginatedData } from "../models/ICommon";
import { IGeneralSettings } from "../models/IGeneralSettings";
import { IMenuItem } from "../models/IMenuItem";
import { IStaticPage } from "../models/IStaticPage";
import { httpService } from "./HttpService";
import { appConfig } from '../config';
import { ISocialFeed } from '../models/ISocialFeed';
import { IBanner } from '../models/IBanner';
import { IPlatformPosts } from '../models/IPlatformPosts';
import { IApplyJobPayload, IDetailedJob, IJob } from '../models/IJob';
import { IPlatformLinks } from '../models/IPlatformLinks';
import { IPlatformSocials } from '../models/IPlatformSocials';

class ApiService {
  private apiBaseUrl = appConfig.apiBaseUrl;

  private readApiBaseUrl = 'https://be-app.eremmedia.io'
  // dependency injection for unit testing
  constructor(protected client = httpService) { }

  getStaticPage(key: string) {
    return this.client.getJSON<IStaticPage>(`${this.readApiBaseUrl}/api/StaticPages/${key}`);
  }


  sendContactMessage(params: {name: string; phone: string; email: string; message: string;}) {
    const {email,message,name,phone} = params;
    const formattedData = {
      Name: name,
      Phone: phone,
      Email: email,
      Message: message
    }
    
    const formData = new FormData();
    for (const [key,val] of Object.entries(formattedData)) formData.set(key,val);
    return this.client.postJSON<void>(`${this.readApiBaseUrl}/api/Actions/contact`,formattedData, {'Content-Type': 'multipart/form-data'});
  }


  applyJob(data: IApplyJobPayload) {
    const formData = new FormData();
    for (const [key,val] of Object.entries(data)) formData.set(key,val);
    return this.client.postJSON<void>(`${this.readApiBaseUrl}/api/Actions/apply`,formData, {'Content-Type': 'multipart/form-data'});
  }


  getJobById(id: number | string) {
    return this.client.getJSON<IDetailedJob>(`${this.readApiBaseUrl}/api/Home/job/${id}`);
  }

  getPlatformsSocials() {
    return this.client.getJSON<IPlatformSocials[]>(`${this.readApiBaseUrl}/api/Home/socials`);
  }

  getPlatformsLinks(filter ={}) {
    return this.client.getJSON<IPlatformLinks[]>(`${this.readApiBaseUrl}/api/Home/links`);
  }
  getJobs(filter ={}) {
    return this.client.getJSON<IJob[]>(`${this.readApiBaseUrl}/api/Home/jobs`);
  }
  getPlatformsPosts() {
    return this.client.getJSON<IPlatformPosts[]>(`${this.readApiBaseUrl}/api/Home/posts`);
  }
  getMenu() {
    return this.client.getJSON<IMenuItem[]>(`${this.readApiBaseUrl}/api/Home/menus`);
  }

  getAMPConfigs() {
    return this.client.getJSON<IAMPConfigs>(`${this.apiBaseUrl}/api/Settings/amp-config`);
  }

  getSiteMapUrls(paging: { page: number; pageSize: number; } = { page: 1, pageSize: 10 }) {
    return this.client.getJSON<IPaginatedData<{
        path: string;
        lastModified: string;
        image?: string;
      }>>(this.getParameterizedUrl(`${this.apiBaseUrl}/api/Sitemap/paged`, paging));
  }

  getAmpSitemapUrls(paging: {page: number; pageSize: number}) {
    return this.client.getJSON<IPaginatedData<{
      path: string;
      lastModified: string;
      image: string;
  }>>(this.getParameterizedUrl(`${this.apiBaseUrl}/api/Sitemap/amp`, paging));
  }

  getGeneralSettings() {
    return this.client.getJSON<IGeneralSettings>(`${this.readApiBaseUrl}/api/Settings/general`);
  }

  listStaticPages() {
    return this.client.getJSON<IStaticPage[]>(`${this.readApiBaseUrl}/api/StaticPages`);
  }


  getBanner(id: number | string) {
    return this.client.getJSON<{}>(`${this.apiBaseUrl}/api/Posts/banners/${id}`);
  }

  listBanners() {
    return this.client.getJSON<IBanner[]>(`${this.apiBaseUrl}/api/Posts/banners/list`);
  }

  private getParameterizedUrl(url: string, params: { [key: string]: any }) {
    const base = new URL(url);
    const filteredParams = Object.entries(params).filter(([_, val]) => typeof val !== 'undefined');
    for (const [key, val] of filteredParams) {
      if (Array.isArray(val)) {
        for (const item of val) base.searchParams.append(key, item);
      } 
      else base.searchParams.set(key, val);
    }
    return base.href;
  }
}

export const apiService = new ApiService();




